import * as ActionTypes from '../constants/actions';

const default_state = {
	currentUser: undefined,
	currentUserRole: undefined,
	currentUserStatus: undefined,
	currentUserConfirmation : "undefined"
};

export default function settings(state = default_state, action) {
	switch (action.type) {
        case ActionTypes.USER.SET_USER_DATA: {
			return {
				...state,
                currentUser : action.currentUser
			};
		}
		case ActionTypes.USER.SET_USER_CONFIRMATION: {
			return {
				...state,
                currentUserConfirmation : action.currentUserConfirmation
			};
		}
		case ActionTypes.USER.SET_USER_ROLE: {
			return {
				...state,
                currentUserRole : action.currentUserRole
			};
		}
		case ActionTypes.USER.SET_USER_STATUS: {
			return {
				...state,
                currentUserStatus : action.currentUserStatus
			};
		}
		case ActionTypes.USER.UNSET_USER_DATA: {
			return {
				...state,
                currentUser : undefined
			};
		}
		case ActionTypes.USER.UNSET_USER_ROLE: {
			return {
				...state,
                currentUserRole : undefined
			};
		}
		case ActionTypes.USER.UNSET_USER_STATUS: {
			return {
				...state,
                currentUserStatus : undefined
			};
		}
		default: {
			return state;
		}
	}
}
